import { Box } from '@material-ui/core'
import { Skeleton as MuiSkeleton } from '@material-ui/lab'

const skeletonLength = Array.from({ length: 4 })

export function LoadingCalendar() {
  return (
    <Box
      role='progressbar'
      display={'flex'}
      flexDirection={'column'}
      gridGap={'1.6rem'}
      width={'100%'}
      overflow={'hidden'}
      marginTop={'4.4rem'}
      paddingRight={'5.2rem'}
    >
      {skeletonLength.map((_, i) => (
        <Box
          key={i}
          minHeight='13.5rem'
          minWidth='100%'
          borderBottom={'1px solid #C3C3C3'}
          paddingBottom={'1.4rem'}
        >
          <MuiSkeleton
            animation='wave'
            width='100%'
            height='100%'
            variant='text'
            style={{ transform: 'initial' }}
          />
        </Box>
      ))}
    </Box>
  )
}
